import { motion } from "framer-motion";
import { User, User2Icon } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import ChatMediaGrid from "./ChatMediaGrid";

const ChatMessage = ({
  message,
  isCurrentUser,
  userAvatar,
  userName,
  otherUserAvatar,
  otherUserName,
  onMediaClick
}) => {
  const timestamp = message.createdAt?.toDate?.() || new Date();

  const renderMessageContent = () => {
    if (message.fileType === "text") {
      return <div className="text-sm p-2">{message.content}</div>;
    }

    if (
      message.fileType === "image" ||
      message.fileType === "video" ||
      message.fileType === "mixed"
    ) {
      return (
        <div className="space-y-2 max-w-xs">
          {message.media?.length > 0 && (
            <ChatMediaGrid
              media={message.media}
              fileTypes={message.fileTypes}
              fileType={message.fileType}
              onMediaClick={onMediaClick}
            />
          )}
          {message.content && (
            <div className="text-sm px-2 py-1 rounded-md">
              {message.content}
            </div>
          )}
        </div>
      );
    }

    return <div className="text-sm p-2">{message.content}</div>;
  };

  return (
    <motion.div
      key={message?.id}
      className={`flex items-end gap-2 ${
        isCurrentUser ? "justify-end" : "justify-start"
      }`}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      {!isCurrentUser && (
        <Avatar className="h-8 w-8">
          {otherUserAvatar && (
            <AvatarImage src={otherUserAvatar} alt={otherUserName} />
          )}
          <AvatarFallback className="bg-secondary text-secondary-foreground">
            <User className="h-5 w-5" />
          </AvatarFallback>
        </Avatar>
      )}

      <div className="flex flex-col max-w-[75%]">
        <div
          className={`rounded-lg px-3 py-2 text-sm shadow-sm ${
            isCurrentUser
              ? "bg-primary text-primary-foreground rounded-br-none self-end"
              : "bg-muted text-muted-foreground rounded-bl-none self-start"
          }`}
        >
          {renderMessageContent()}
        </div>

        <span
          className={`text-xs text-gray-400 mt-1 ${
            isCurrentUser ? "text-right" : "text-left"
          }`}
        >
          {timestamp.toLocaleString([], {
            hour: "2-digit",
            minute: "2-digit"
          })}
        </span>
      </div>

      {isCurrentUser && (
        <Avatar className="h-8 w-8">
          {userAvatar && (
            <AvatarImage src={userAvatar} alt={userName || "User"} />
          )}
          <AvatarFallback>
            <User2Icon className="h-5 w-5" />
          </AvatarFallback>
        </Avatar>
      )}
    </motion.div>
  );
};

export default ChatMessage;
